<template>
  <div class="feed-card feed__message-block">
    <div class="d-flex position-relative">
      <span class="v-line"></span>
      <span class="circle-step flex-shrink-0"></span>

      <div class="content">
        <h3 v-html="userActivity.title_html"></h3>
        <p v-html="userActivity.assistance_message">
        </p>

        <TimeInfos :userActivity="userActivity"/>
      </div>
    </div>
  </div>
</template>


<script>
  import TimeInfos from '@components/utils/TimeInfos.vue';

  export default {
    props: {
      userActivity: Object
    },
    components: {
      TimeInfos
    },
  };
</script>